import menuComponent from './mainMenu.component';

let menuModule = angular.module('mainMenu', [ ])

.component('mainMenu', menuComponent)
.name;

export default menuModule;



// WEBPACK FOOTER //
// ./client/app/components/mainMenu/mainMenu.js